import { render } from "./ShortageItem.vue?vue&type=template&id=2393ccf1"
import script from "./ShortageItem.vue?vue&type=script&lang=js"
export * from "./ShortageItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__